import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <section className="py-8 md:py-16 bg-brand-dark border-b border-brand-card" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-10" data-id="element-147">
          <h2 className="text-2xl md:text-3xl font-playfair text-white" data-id="element-148">
            Más de <span className="text-brand-gold" data-id="element-149">900 clientes</span> confían
            en Le Barber Club
          </h2>
        </motion.div>

        <div className="grid grid-cols-3 gap-2 md:gap-8 text-center md:divide-x divide-brand-card" data-id="element-150">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="py-4 md:py-0" data-id="element-151">
            <div className="text-4xl font-bold text-brand-gold mb-2 font-playfair" data-id="element-152">
              900+
            </div>
            <div className="text-brand-gray text-sm uppercase tracking-wider" data-id="element-153">
              Clientes satisfechos
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="py-4 md:py-0" data-id="element-154">
            <div className="text-4xl font-bold text-brand-gold mb-2 font-playfair" data-id="element-155">
              5 ⭐
            </div>
            <div className="text-brand-gray text-sm uppercase tracking-wider" data-id="element-156">
              Calificación promedio
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="py-4 md:py-0" data-id="element-157">
            <div className="text-4xl font-bold text-brand-gold mb-2 font-playfair" data-id="element-158">
              3+
            </div>
            <div className="text-brand-gray text-sm uppercase tracking-wider" data-id="element-159">
              Años de experiencia
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}